module.exports = __webpack_public_path__ + "static/media/analytics1.21583134.png";